import React, {useEffect, useMemo, useState} from "react";
import { useForm } from "react-hook-form";
import OWASP from "../../../util/owasp";
import CONFIGURACIONES from "../../../util/constants";
import WaveButton from "../WaveButton.jsx";
import DatePicker, {registerLocale} from "react-datepicker";
import { es } from "date-fns/locale"; 
import { parse, format } from "date-fns";

import "react-datepicker/dist/react-datepicker.css";

registerLocale("es-sunday", {
  ...es,
  options: {
    ...es.options,
    weekStartsOn: 0, // 0 = Domingo, 1 = Lunes
  },
});

const MovimientosCajaModal = ({ show, onClose, onSave, showCreate, title, initDataApertura }) => {
    const { handleSubmit: handleSubmitModal, setValue: setValueModal, register: registerModal, reset: resetModal, formState: { errors: errorsModal } } = useForm({mode: "onChange"});
    const [nombreCaja, setNombreCaja] = useState(CONFIGURACIONES.INIT.STRING);
    const [monedas, setMonedas] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [conceptosPago, setConceptosPago] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [mediosPago, setMediosPago] = useState(CONFIGURACIONES.INIT.ARRAY);

    const [valueTipo, setValueTipo] = useState(CONFIGURACIONES.INIT.STRING);
    const [valueConceptoPagoId, setValueConceptoPagoId] = useState(CONFIGURACIONES.INIT.STRING);
    const [valueMedioPago, setValueMedioPago] = useState(CONFIGURACIONES.INIT.NULL);
    const [fechaActual, setFechaActual] = useState(new Date());
    const [fechaDatePicker, setFechaDatePicker] = useState(CONFIGURACIONES.INIT.STRING);

    useEffect(() => {
        resetModal();
        if (initDataApertura !== CONFIGURACIONES.INIT.NULL && initDataApertura.cajaActiva !== CONFIGURACIONES.INIT.NULL) {
           setNombreCaja(initDataApertura.cajaActiva.nombre_caja)
           setMonedas(initDataApertura.monedas);
           setConceptosPago(initDataApertura.conceptosPago);
           setMediosPago(initDataApertura.detallesConceptoPago)
           setFechaDatePicker(fechaActual);
           setValueModal('fecha', format(fechaActual, "yyyy-MM-dd"));
        }
    }, [initDataApertura]);


    const selectConceptosPago = useMemo(() => {
        return conceptosPago.filter(item => item.tipo == valueTipo);
    }, [conceptosPago, valueTipo]);

    const selectMediosPago = useMemo(() => {
        return mediosPago.filter(item => item.concepto_pago_id == valueConceptoPagoId)
    }, [mediosPago, valueConceptoPagoId]);

    const saveData = (form) => {
        let data = {
            'fecha': form.fecha,
            'movimientoCajaId': initDataApertura.cajaActiva.id,
            'tipo': form.tipo,
            'conceptoPagoId': form.conceptoPagoId,
            'metodoPagoId': form.metodoPagoId,
            'monto': form.monto,
            'moneda': form.moneda,
            'formaPago': valueMedioPago.forma_pago,
            'observacion': form.observacion
        }

        onSave(data);
    };
    return (
        <div
            className={`modal fade ${show ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{ background: "rgba(0,0,0,0.5)" }}
        >
            <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
                <form className="modal-content" action="" onSubmit={handleSubmitModal(saveData)} autoComplete="off">
                    <div className="modal-header">
                        <h5 className="modal-title"> {title}</h5>
                        <button type="button" className="close" onClick={onClose}>
                            <span>&times;</span>
                        </button>
                    </div>

                    <div className="modal-body">
                        <div className="row">
                            <div className="col-xs-12 col-md-2">
                                <div className="form-group">
                                    <label htmlFor="fecha" className="control-label col-form-label">Fecha <span className="text-danger">*</span></label>
                                    <DatePicker dateFormat={"dd/MM/yyyy"}
                                        id="fechaDatePicker"
                                        placeholderText="dd / mm / aaaa"
                                        className="form-control text-center"
                                        locale="es-sunday"
                                        selected={fechaDatePicker}
                                        dayClassName={(date) =>
                                            date.getDay() === 0 || date.getDay() === 6 ? "weekend-day" : undefined
                                        }
                                        onChange={(date) => {
                                            setFechaDatePicker(date);
                                            setValueModal('fecha', format(date, "yyyy-MM-dd"), {shouldValidate: true});
                                        }}
                                        onChangeRaw={(e) => e.preventDefault()}
                                        showMonthDropdown
                                        showYearDropdown
                                        popperClassName="datepicker-popper"
                                        maxDate={fechaActual}
                                    />
                                    <input
                                        {...registerModal('fecha', {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.DATE,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                        type="hidden"/>
                                    <small
                                        className="invalid-feedback"> {errorsModal.fecha && errorsModal.fecha.message}</small>
                                </div>
                            </div>
                            
                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="caja" className="control-label col-form-label">Caja <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="caja"
                                        id="caja"
                                        {...registerModal("caja", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            },
                                            disabled: CONFIGURACIONES.INIT.STATUS_TRUE,
                                            value: nombreCaja
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.caja && errorsModal.caja.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="tipo" className="control-label col-form-label">Tipo <span className="text-danger">*</span></label>
                                    <select
                                        {...registerModal("tipo", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            },
                                            onChange: (e) => {
                                                setValueTipo(e.target.value);
                                                setValueConceptoPagoId(CONFIGURACIONES.INIT.STRING);
                                                
                                                setValueModal('conceptoPagoId', CONFIGURACIONES.INIT.STRING);
                                                setValueModal('metodoPagoId', CONFIGURACIONES.INIT.STRING);

                                                setValueMedioPago(CONFIGURACIONES.INIT.NULL);
                                                setValueModal('formaPago', CONFIGURACIONES.INIT.STRING);
                                            }
                                        })} className="form-control" id="tipo"
                                        defaultValue={""}
                                    >
                                        <option value="" disabled>Seleccione</option>
                                        {
                                            CONFIGURACIONES.INIT.LIST.TIPOS_MOVIMIENTOS_CAJA.map((el, index) => (
                                                <option key={index} value={el.id}>{el.nombre}</option>
                                            ))
                                        }
                                    </select>
                                    <small className="invalid-feedback"> { errorsModal.tipo && errorsModal.tipo.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4">
                                <div className="form-group">
                                    <label htmlFor="conceptoPagoId" className="control-label col-form-label">Concepto <span className="text-danger">*</span></label>
                                    <select
                                        {...registerModal("conceptoPagoId", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            },
                                            onChange: (e) => {
                                                setValueConceptoPagoId(e.target.value);
                                                setValueModal('metodoPagoId', CONFIGURACIONES.INIT.STRING);

                                                setValueMedioPago(CONFIGURACIONES.INIT.NULL);
                                                setValueModal('formaPago', CONFIGURACIONES.INIT.STRING);
                                            }
                                        })} className="form-control" id="conceptoPagoId"
                                        defaultValue={""}
                                    >
                                        <option value="" disabled>Seleccione</option>
                                        {
                                            selectConceptosPago.map((el, index) => (
                                                <option key={index} value={el.id}>{el.nombre}</option>
                                            ))
                                        }
                                    </select>
                                    <small className="invalid-feedback"> { errorsModal.concepto && errorsModal.concepto.message }</small>
                                </div>
                            </div>                            
                        </div>

                        <div className="row">
                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="metodoPagoId" className="control-label col-form-label">Medio de Pago <span className="text-danger">*</span></label>
                                    <select
                                        {...registerModal("metodoPagoId", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            },
                                            onChange: (e) => {
                                                let elm = selectMediosPago.find(item => item.id == e.target.value); 
                                                setValueMedioPago(elm);
                                                setValueModal('formaPago', elm.forma_pago);
                                            }
                                        })} className="form-control" id="metodoPagoId"
                                        defaultValue={""}
                                    >
                                        <option value="" disabled>Seleccione</option>
                                        {
                                            selectMediosPago.map((el, index) => (
                                                <option key={index} value={el.id}>{el.nombre}</option>
                                            ))
                                        }
                                    </select>
                                    <small className="invalid-feedback"> { errorsModal.metodoPagoId && errorsModal.metodoPagoId.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="monto" className="control-label col-form-label">Monto <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="monto"
                                        id="monto"
                                        {...registerModal("monto", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.monto && errorsModal.monto.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="moneda" className="control-label col-form-label">Moneda <span className="text-danger">*</span></label>
                                    <select
                                        {...registerModal("moneda", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            },
                                        })} className="form-control" id="moneda"
                                        defaultValue={""}
                                    >
                                        <option value="" disabled>Seleccione</option>
                                        {
                                            monedas.map((el, index) => (
                                                <option key={index} value={el.nombre}>{el.nombre}</option>
                                            ))
                                        }
                                    </select>
                                    <small className="invalid-feedback"> { errorsModal.moneda && errorsModal.moneda.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="formaPago" className="control-label col-form-label">Forma de Pago <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="formaPago"
                                        id="formaPago"
                                        {...registerModal("formaPago", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            },
                                            disabled: CONFIGURACIONES.INIT.STATUS_TRUE,
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsModal.formaPago && errorsModal.formaPago.message }</small>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12 col-md-12">
                                <div className="form-group">
                                    <label htmlFor="observacion" className="control-label col-form-label">Observaciones </label>
                                    <textarea
                                        type="text"
                                        className="form-control no-resize"
                                        name="observacion"
                                        rows={3}
                                        id="observacion"
                                        {...registerModal("observacion", {
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    ></textarea>
                                    <small className="invalid-feedback"> { errorsModal.observacion && errorsModal.observacion.message }</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <WaveButton type="button" className="btn btn-sm btn-outline-danger" onClick={() => onClose(CONFIGURACIONES.INIT.FLAG_CLOSE)}>
                            <i className="mdi mdi-arrow-left"></i> Cerrar
                        </WaveButton>
                        {showCreate && <WaveButton type="submit" className="btn btn-sm btn-success waves-effect">
                            <i className="mdi mdi-content-save-settings"></i> Guardar
                        </WaveButton>}
                    </div>
                </form>
            </div>
        </div>
    );
};
export default MovimientosCajaModal;
